<!-- background -->
<div class="title-part background-gradient">
	<div class="element-show text-base-100 h-container main-container" [style.--i]="0">
		<img class="h-logo" src="img/logo/white-full.png" alt="Legend-binder">
		<p class="text-2xl">Ta collection mérite mieux qu’un simple classeur</p>
		<p class="h-title uppercase">Passe au niveau légendaire</p>
		<h1 class="text-lg text-base-100">L’application pour organiser ta collection TCG</h1>
	</div>
</div>

<!-- phones -->
<div class="phone-container main-container">
	<div class="element-show phone" [style.--i]="1">
		<op-phone screen="img/skin/screen/s-10.png" title="cartes"></op-phone>
	</div>
	<div class="element-show phone-xl" [style.--i]="2">
		<op-phone screen="img/skin/screen/s-7.png" title="cartes"></op-phone>
	</div>
	<div class="element-show phone" [style.--i]="3">
		<op-phone screen="img/skin/screen/s-9.2.png" title="cartes"></op-phone>
	</div>
</div>

<!-- downloads -->
<div class="dowloads-container main-container">
	<a [attr.href]="url" class="m-4 btn btn-primary btn-gradient btn-xl" title="donwloads IOS app">
		<i class="fa-brands fa-apple pr-2"></i>Installer<br/>
	</a>
	<a [attr.href]="url" class="m-4 btn btn-primary btn-gradient btn-xl" title="donwloads Android app">
		<i class="fa-brands fa-google-play pr-2"></i>Installer
	</a>
</div>

<div class="element-show why-container" [style.--i]="5">
	<div class="text-center mb-8">
		<p class="mb-2 text-lg">Une nouvelle façon de gérer votre collection.</p>
		<h2 class="title-bloc text-primary">Chaque binder devient unique</h2>
	</div>
	<div class="card-container">
		<div class="binder-texts">
			<!-- 1 - créer un binder virtuel -->
			<div class="binder-text mb-8">
				<div class="mr-3">
					<div class="binder-number-container">
						<img src="img/skin/number-violet.png" alt="logo-number"/>
						<span class="number text-3xl text-primary">1</span>
					</div>
				</div>
				<div>
					<h3 class="text-lg text-primary">Crée ton binder vituel</h3>
					<p>Scanne le QR Code à l’intérieur du binder ou ajoute un binder existant.</p>
				</div>
			</div>

			<!-- 2 - Scannez les pages de votre collection -->
			<div class="binder-text mb-8">
				<div class="mr-3">
					<div class="binder-number-container">
						<img src="img/skin/number-violet.png" alt="logo-number"/>
						<span class="number text-3xl text-primary">2</span>
					</div>
				</div>
				<div>
					<h3 class="text-lg text-primary">Scanne les pages de votre collection</h3>
					<p>Reconnaissance automatique des cartes et des prix.</p>
				</div>
			</div>
			
			<!-- 3 - Gérez votre collection -->
			<div class="binder-text mb-8">
				<div class="mr-3">
					<div class="binder-number-container">
						<img src="img/skin/number-violet.png" alt="logo-number"/>
						<span class="number text-3xl text-primary">3</span>
					</div>
				</div>
				<div>
					<h3 class="text-lg text-primary">Gére ta collection</h3>
					<p>Visualise, modifie et transfére tes binders.</p>
				</div>
			</div>
			
			<!-- 4 - Partagez votre collection -->
			<div class="binder-text mb-8">
				<div class="mr-3">
					<div class="binder-number-container">
						<img src="img/skin/number-violet.png" alt="logo-number"/>
						<span class="number text-3xl text-primary">4</span>
					</div>
				</div>
				<div>
					<h3 class="text-lg text-primary">Partage ta collection</h3>
					<p>Envoie tes cartes à tes amis ou collectionneurs même sans l'application.</p>
				</div>
			</div>
		</div>
		<div class="binder-container">
			<img src="img/skin/binder-side.jpg" alt="Binder"/>
		</div>
	</div>
</div>


<!-- features -->
<div class="feat-bloc p-8 bg-base-200">
	<div class="feat-container element-show" [style.--i]="6">
		<div class="text-center">
			<p class="mb-2 text-lg">Gestion de collection, simplifiée.</p>
			<h2 class="title-bloc text-primary">Fonctionnalités</h2>
		</div>
		<div class="carousel-container">
			<div class="feat-phone-container">
				<div class="feat-phone">
					<op-phone screen="img/skin/screen/s-6.png" title="Fonctionnalités"></op-phone>
				</div>
			</div>
			<div class="carousel carousel-center rounded-box w-full space-x-4 p-4">
				<!-- feat 1 -->
		  		<div class="carousel-item">
					<div class="card bg-primary text-primary-content w-full">
					  <div class="card-body">
					    <h3 class="card-title uppercase text-base-100">01 - Scan et détection automatique</h3>
					    <p class="card-text text-lg">Scan intelligent : scannez votre binder en quelques secondes. L’application identifie automatiquement les cartes de chaque page, la langue et les informations essentielles, sans saisie manuelle.</p>
					  </div>
					</div>
				</div>	

				<!-- feat 2 -->
		  		<div class="carousel-item">
					<div class="card bg-primary text-primary-content w-full">
					  <div class="card-body">
					    <h3 class="card-title uppercase text-base-100">02 - Valorisation des cartes</h3>
					    <p class="card-text text-lg">Valorisation précise : obtenez une estimation fiable basée sur la langue, l’état et les données issues des principales marketplaces comme Cardmarket ou eBay.</p>
					  </div>
					</div>
				</div>	

				<!-- feat 3 -->
		  		<div class="carousel-item">
					<div class="card bg-primary text-primary-content w-full">
					  <div class="card-body">
					    <h3 class="card-title uppercase text-base-100">03 - Partage sans application</h3>
					    <p class="card-text text-lg">Partage simplifié : partagez votre collection via un simple lien. Vos proches peuvent la consulter librement, sans créer de compte ni installer l’application</p>
					  </div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<!-- tcg -->
<div class="element-show games-container main-container" [style.--i]="7">
	<p class="mb-2 text-lg">Les jeux déjà supportés.</p>
	<h2 class="title-bloc mb-4 text-primary">TCG compatibles</h2>
	<p class="mb-2 text-lg">Legend-Binder évolue en continu. De nouveaux TCG sont intégrés régulièrement afin de couvrir progressivement l’ensemble des TCG majeurs.</p>
	<div class="tcg-container">
		<div class="card bg-base-100 shadow-sm tcg-element my-2 p-4">
			<img src="img/skin/types/pkm.png" alt="Pokémon"/> 
		</div>
		<div class="card grey bg-base-100 shadow-sm tcg-element my-2 p-4">
			<img src="img/skin/types/magic.png" alt="Magic"/> 
		</div>
		<div class="card grey bg-base-100 shadow-sm tcg-element my-2 p-4">
			<img src="img/skin/types/lrc.webp" alt="Lorcana"/> 
		</div>
		<div class="card grey bg-base-100 shadow-sm tcg-element my-2 p-4">
			<img src="img/skin/types/yugi.png" alt="Yugioh"/> 
		</div>
		<div class="card grey bg-base-100 shadow-sm tcg-element my-2 p-4">
			<img src="img/skin/types/op.webp" alt="One Piece"/> 
		</div>
		<div class="card grey bg-base-100 shadow-sm tcg-element my-2 p-4">
			<img src="img/skin/types/sw.png" alt="Star Wars"/> 
		</div>
		<div class="card grey bg-base-100 shadow-sm tcg-element my-2 p-4">
			<img src="img/skin/types/dragonball-z.png" alt="Dragon Ball Z"/> 
		</div>
		<div class="card grey bg-base-100 shadow-sm tcg-element my-2 p-4">
			<img src="img/skin/types/hptcglogo.png" alt="Harry Potter"/> 
		</div>
	</div>
</div>

<!-- last-cta -->
<div class="mt-8 element-show last-cta" [style.--i]="8">
	<div class="main-container">
		<div class="text-center mb-4">
			<p class="mb-2 text-lg">Commencez maintenant.</p>
			<h2 class="title-bloc text-primary">Installer l'application</h2>
		</div>
		<div class="app-container">
			<a [attr.href]="url" title="iOS app" class="app mr-8">
				<span class="app-icon">
					<i class="fa-brands fa-apple pr-3"></i>
				</span>
				<span>
					Disponlible<br/>
					sur iOS
				</span>
			</a>
			<a [attr.href]="url" title="Android app" class="app">
				<span class="app-icon">
					<i class="fa-brands fa-google-play pr-3"></i>
				</span>
				<span>
					Disponlible<br/>
					sur Android
				</span>
			</a>
		</div>
	</div>
</div>

<div class="element-show follow-container main-container" [style.--i]="9">
	<div class="text-center mb-4">
		<p class="mb-2 text-lg">Participez à nos concours.</p>
		<h2 class="title-bloc text-primary">Suivez-nous</h2>
	</div>

	<div class="rs-container">
		<div class="social-icon mr-8">
			<a href="https://www.facebook.com/people/Legend-Binder/61588921773391/" title="facebook">
				<i class="text-base-100 text-6xl fa-brands fa-facebook-f"></i>
			</a>
		</div>

		<div class="social-icon orange mr-8">
			<a href="https://www.instagram.com/legend_binder/" title="instagram">
				<i class="text-base-100 text-6xl fa-brands fa-instagram"></i>
			</a>
		</div>

		<div class="social-icon black">
			<a href="https://www.tiktok.com/@legend_binder" title="tiktok">
				<i class="text-base-100 text-6xl fa-brands fa-tiktok"></i>
			</a>
		</div>
	</div>
</div>